import React from "react";
import {
  Box,
  Card,
  Container,
  Typography,
  Button,
  Grid,
  Chip,
} from "@mui/material";

const plans = [
  {
    title: "Foundation",
    price: 19,
    features: [
      "Homework & Assignments",
      "Parent–School Communication",
      "Transport Tracking",
    ],
  },
  {
    title: "Core",
    price: 49,
    badge: "MOST_POPULAR",
    features: [
      "All Foundation Features",
      "AI Homework Assistant",
      "100 AI Questions / Month",
    ],
  },
  {
    title: "Plus",
    price: 99,
    features: [
      "All Core Features",
      "Advanced Performance Insights",
      "Detailed AI Explanations",
    ],
  },
];

const ParentUpgrade = () => {
  return (
    <Container maxWidth="md" sx={{ pt: 10, pb: 10 }}>
      <Box textAlign="center" mb={6}>
        <Typography variant="h3" fontWeight={700}>
          Upgrade Parent Plan
        </Typography>

        <Typography color="text.secondary">
          Unlock AI learning support and full school access
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {plans.map((plan) => (
          <Grid item xs={12} md={4} key={plan.title}>
            <Card sx={{ p: 4, borderRadius: 4, textAlign: "center" }}>
              {plan.badge && (
                <Chip
                  label="Most Popular"
                  color="primary"
                  sx={{ mb: 2 }}
                />
              )}

              <Typography variant="h5" fontWeight={700}>
                {plan.title}
              </Typography>

              <Typography variant="h4" mt={1} fontWeight={700}>
                ₹{plan.price}
                <Typography component="span" variant="body2">
                  {" "}
                  / month
                </Typography>
              </Typography>

              <Box mt={3}>
                {plan.features.map((f, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    sx={{ mb: 1 }}
                  >
                    ✔ {f}
                  </Typography>
                ))}
              </Box>

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
              >
                Upgrade Now
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ParentUpgrade;